import { useEffect, useState } from 'react';

const navLinks = [
  { href: '#daily', label: '今日精选', icon: 'ri-star-line' },
  { href: '#hot', label: '人气榜单', icon: 'ri-fire-line' },
  { href: '#booklist', label: '追更书单', icon: 'ri-bookmark-line' },
  { href: '#category', label: '主题分类', icon: 'ri-grid-fill' },
  { href: '#about', label: '编辑口碑', icon: 'ri-team-line' },
  { href: '#faq', label: '常见问题', icon: 'ri-question-line' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'border-b border-background-800 bg-background-950/90 backdrop-blur-md'
          : 'border-b border-transparent bg-transparent'
      }`}
    >
      <nav className="mx-auto flex h-16 max-w-7xl items-center justify-between px-4 md:px-6">
        <a href="#hero" className="flex items-center gap-2">
          <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-lg text-foreground-950">
            <i className="ri-leaf-fill" />
          </span>
          <span className="font-heading text-xl font-bold text-primary-300">香蕉漫画社</span>
        </a>

        <div className="hidden items-center gap-1 lg:flex">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="group inline-flex items-center gap-1.5 rounded-md px-3 py-2 text-sm text-foreground-300 transition-colors hover:bg-background-800 hover:text-primary-300"
            >
              <i className={`${link.icon} text-[15px] text-foreground-500 transition-colors group-hover:text-primary-400`} />
              {link.label}
            </a>
          ))}
        </div>

        <div className="flex items-center gap-3">
          <a
            href="#booklist"
            className="hidden whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-bold text-foreground-950 transition-colors hover:bg-primary-400 sm:inline-flex"
          >
            <i className="ri-bookmark-fill mr-1.5 text-[14px]" />
            开始追漫
          </a>
          <button
            type="button"
            aria-label="打开菜单"
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-md border border-background-800 text-xl text-foreground-200 lg:hidden"
          >
            <i className={open ? 'ri-close-line' : 'ri-menu-line'} />
          </button>
        </div>
      </nav>

      {open && (
        <div className="border-t border-background-800 bg-background-950/95 px-4 py-4 backdrop-blur-md lg:hidden">
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="inline-flex items-center gap-3 rounded-md px-3 py-3 text-sm text-foreground-200 hover:bg-background-800"
              >
                <i className={`${link.icon} text-base text-primary-400`} />
                {link.label}
              </a>
            ))}
            <a
              href="#booklist"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex items-center justify-center rounded-md bg-primary-500 px-4 py-3 text-sm font-bold text-foreground-950"
            >
              开始追漫
            </a>
          </div>
        </div>
      )}
    </header>
  );
}